// The Comic Machine - Mouse

var Mouse = (function() {

  // Configuration settings/properties
  var config = {
    defaults: {
      isMoving: false,
      initialPosition: {
        x: 0,
        y: 0
      },
      currentPosition: {
        x: 0,
        y: 0
      },
      offsetPosition: {
        x: 0,
        y: 0
      }
    }
  };

  var isMoving = config.defaults.isMoving;
  var initialPosition = config.defaults.initialPosition;
  var currentPosition = config.defaults.currentPosition;
  var offsetPosition = config.defaults.offsetPosition;

  var Mouse = {

    isMoving: isMoving,
    initialPosition: initialPosition,
    currentPosition: currentPosition,
    offsetPosition: offsetPosition,

    // On mouse down
    down: function(event) {

      if (isMoving) {
        return;
      }

      var offset = Mouse.getOffset();

      initialPosition = {
        x: event.pageX - offset.left,
        y: event.pageY - offset.top
      };

      currentPosition = {
        x: initialPosition.x,
        y: initialPosition.y
      };

      isMoving = true;

      return {
        currentPosition: currentPosition,
        initialPosition: initialPosition
      };

    },

    // On mouse move
    move: function(event) {

      if (!isMoving) {
        return;
      }

      var offset = Mouse.getOffset();

      currentPosition = {
        x: event.pageX - offset.left,
        y: event.pageY - offset.top
      };

      offsetPosition = {
        x: currentPosition.x - initialPosition.x,
        y: currentPosition.y - initialPosition.y
      };

      return {
        currentPosition: currentPosition,
        offsetPosition: offsetPosition
      };

    },

    // On mouse up
    up: function(event) {

      if (!isMoving) {
        return;
      }

      var offset = Mouse.getOffset();

      currentPosition = {
        x: event.pageX - offset.left,
        y: event.pageY - offset.top
      };

      isMoving = false;

      return {
        currentPosition: currentPosition,
        offsetPosition: offsetPosition
      };

    },

    // Gets the click offset in relation to the canvas position
    getOffset: function() {
      return {
        left: cumulativeOffset(Canvas.base.element).left -
          CanvasController.elements.container.scrollLeft +
          (Canvas.size.offset * Canvas.base.scale),
        top: cumulativeOffset(Canvas.base.element).top -
          CanvasController.elements.container.scrollTop +
          (Canvas.size.offset * Canvas.base.scale),
      };
    }

  };

  // Public / exposed objects
  return Mouse;

})();


// The Comic Machine - Drag

var Drag = (function() {

  // Configuration settings/properties
  var config = {
    defaults: {
      isDragging: false,
      listItems: [],
      currentElement: null,
      currentIndex: null,
      previousIndex: null
    },
    classes: {
      selected: "list-drag-selected",
      hovered: "list-drag-hover"
    },
    dataType: "text/plain",
    dragEffect: "move"
  };

  // Handle on drag start
  function dragStart(event) {

    if (this.isDragging) {
      return;
    }

    this.isDragging = true;

    // Get original element
    this.currentElement = event.target;
    // Get initial index
    this.currentIndex = this.listItems.indexOf(this.currentElement);

    // Hide original element
    this.currentElement.className += " " + config.classes.selected;

    // Set element data
    event.dataTransfer.setData(config.dataType, event.target.innerHTML);
    // Set transfer effect
    event.dataTransfer.effectAllowed = config.dragEffect;

  }

  // Handle on drag over
  function dragOver(event) {

    if (!this.isDragging) {
      return;
    }

    // Prevent default functionality
    event.preventDefault();

    // Active index of the hover target
    var activeIndex = null;

    // Set drop effect
    event.dataTransfer.dropEffect = config.dragEffect;

    // Check hover item
    this.listItems.forEach(function(li, i) {
      if (i === this.currentIndex) {
        return;
      }
      activeIndex = li === event.target ? i : activeIndex;
    });

    // Check if list should update
    if (activeIndex === this.previousIndex || activeIndex === null) {
      return;
    }

    // Reorder the list items with the new index
    this.reorderListItems(activeIndex);

    // Update index references
    this.previousIndex = activeIndex;
    this.currentIndex = activeIndex;

  }

  // Handle on drag drop
  function dragDrop(event) {

    if (!this.isDragging) {
      return;
    }

    this.isDragging = false;

    // Prevent default functionality
    event.preventDefault();
    event.stopPropagation();

    // Reset style
    this.resetListStyles();

    // Reset styles and return if no change is required
    // this.currentElement === event.target && return this.resetListStyles();
    // Set dragged item content
    // this.currentElement.innerHTML = event.target.innerHTML;
    // Set drop item content
    // event.target.innerHTML = event.dataTransfer.getData("text/plain");
    // Get new index
    // var index = listItems.indexOf(document.querySelector(".selected"));

  }

  // Handle on drag end
  function dragEnd(event) {

    this.isDragging = false;

    if (event.target === this.currentElement) {
      // Reset style
      this.resetListStyles();
    }

  }

  // Method to rReorder the list items with the new index
  function reorderListItems(index) {

    var self = this;

    // Placeholder list for list item content
    var list = [];

    // Cache list item content and empty elements
    this.listItems.forEach(function(li) {
      list.push(li.querySelector("div"));
      li.innerHTML = "";
    });

    // Reorder the list items
    list.move(this.currentIndex, index);
    Comic.current.pageList.move(this.currentIndex, index);

    // Append the cached items in the revised order
    list.forEach(function(item, i) {
      self.listItems[i].appendChild(item);
      self.listItems[i].className = i === index ? config.classes.selected : "";
    });

    // Fire custom event to notify listeners
    Events.global.emit("tcm.list.sorted", {
      current: this.currentIndex,
      index: index,
      list: this.listItems,
      callback: function() {
        // Append the cached items in the revised order
        list.forEach(function(item, i) {
          self.listItems[i].appendChild(item);
          self.listItems[i].className = i === index ? config.classes.selected : "";
        });
      }
    });

  }

  // Method to reset the list styles
  function resetListStyles() {

    // Reset style
    this.listItems.forEach(function(li) {
      li.className = "";
    });

  }

  // Public / exposed objects
  return {

    // Sortable
    Sortable: function(listElement) {

      var sortable = this;

      // Return with error if no list element passed
      if (!listElement) {
        return console.error("no list element");
      }

      // Placeholder flag for dragging
      this.isDragging = config.defaults.isMoving;

      // The list element and child items
      this.listElement = listElement;
      this.listItems = document.queryAll("li", listElement) || config.defaults.listItems;

      // Placeholders for caching dragged elements and indices
      this.currentElement = config.defaults.currentElement;
      this.currentIndex = config.defaults.currentIndex;
      this.previousIndex = config.defaults.previousIndex;

      // On drag start
      sortable.start = dragStart;
      // On drag over
      sortable.over = dragOver;
      // On drag drop
      sortable.drop = dragDrop;
      // On drag end
      sortable.end = dragEnd;
      // On drag exit
      //sortable.exit = dragExit;

      // Loop over list item elements to bind event handlers
      this.listItems.forEach(function(list, i) {
        // On drag start
        list.ondragstart = function(event) {
          sortable.start(event);
        };
        // On drag over
        document.body.ondragover = function(event) {
          sortable.over(event);
        };
        // On drag drop
        list.ondrop = function(event) {
          sortable.drop(event);
        };
        // On drag end
        list.ondragend = function(event) {
          sortable.end(event);
        };
        // On drag exit
        //list.ondragexit = this.exit;
      });

      // Method to rReorder the list items with the new index
      this.reorderListItems = reorderListItems;

      // Method to reset the list styles
      this.resetListStyles = resetListStyles;

    }

  };

})();
